import { useContext, createContext } from 'react';

import type { HawkWidgetContextType } from './model';

export const HawkWidgetContext = createContext({} as HawkWidgetContextType);
export const useHawkWidgetContext = (): HawkWidgetContextType => useContext(HawkWidgetContext);
